<ng-content select="[crmTgbotSideNavDropdownTrigger]"></ng-content>
<ng-content select="ng-template[crmTgbotSideNavDropdownPanel]"></ng-content>
